"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../constants");
const styleOverrides = {
  root: {
    fontSize: '1.2rem',
    color: _constants.colors.oriGrey[500],
    justifyContent: 'center'
  },
  selectLabel: {
    fontSize: '1.2rem'
  },
  displayedRows: {
    fontSize: '1.2rem'
  },
  actions: {
    display: 'inline-flex',
    gap: 15
  }
};
const defaultProps = {
  // SelectProps: { variant: 'outlined', size: 'small' },
};
var _default = exports.default = {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiTablePagination.js.map